/*
 * Copyright (c) 2020 CalAmp Corp.  All Rights Reserved
 */
import React from 'react';
import {makeStyles} from '@material-ui/core/styles';
import {translate} from '@ion/core/src/locale/locale';

const useStyles = makeStyles(theme => ({
  loading : {
    fontSize  : '12px',
    padding   : '5px',
    textAlign : 'center'
  }
}));

/**
 * @LoadingText
 *
 * Standard loading text for small loading instances
 *
 * ```typescript
 *
 *   <LoadingText />
 *
 * ```
 */
const LoadingText = () => {
  const classes = useStyles();
  return (
    <div className={classes.loading}>{translate('common:states.loading')}</div>
  );
};

export default LoadingText;
